import { getDefaultExportFromCjs as r } from "./_commonjsHelpers.js";
import { __require as o } from "../bundled_deps/.pnpm/@intercom_intermoji@2.0.0/bundled_deps/@intercom/intermoji/lib/intermoji.js";
var t = o();
const m = /* @__PURE__ */ r(t);
export {
  m as default
};
